
import { ProcessStep } from "@/components/services/cybersecurity/ProcessStep";

export const ProcessJourneySection = () => {
  return (
    <section className="py-16 bg-white" aria-labelledby="process-heading">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-purple-100 text-purple-800 rounded-full text-sm font-medium mb-5">Your Transformation Journey</span>
          <h2 id="process-heading" className="text-3xl sm:text-4xl font-bold mb-6 text-gray-900">
            From Security Chaos to Business Growth
          </h2>
          <p className="text-xl text-gray-600">
            Our proven process guides you from uncertainty to a security program that drives business success.
          </p>
        </div>
        
        <div className="max-w-5xl mx-auto">
          <div className="relative">
            {/* Vertical line */}
            <div className="absolute left-6 top-8 bottom-8 w-0.5 bg-purple-200 hidden sm:block"></div>
            
            <div className="space-y-12">
              <ProcessStep 
                number={1}
                title="Understand Your Business & Security Challenges"
                description="We begin with a deep dive into your business context and security challenges:"
                bulletPoints={[
                  "Executive interviews to understand what's keeping you up at night",
                  "Assessment of your current security posture and compliance requirements",
                  "Identification of specific security obstacles blocking your growth"
                ]}
                testimonial="edgefi didn't start with technical checklists—they first made sure they truly understood our business challenges and what was holding us back."
              />
              
              <ProcessStep 
                number={2}
                title="Create Your Strategic Security Roadmap"
                description="We develop a practical security strategy aligned with your business goals:"
                bulletPoints={[
                  "Prioritized security initiatives that directly support your growth objectives",
                  "Clear implementation plan with defined milestones and resource requirements",
                  "Executive-friendly materials that demonstrate security's business value"
                ]}
                testimonial="For the first time, we could see exactly how security investments would support our business growth rather than just being a cost center."
              />
              
              <ProcessStep 
                number={3}
                title="Implement Your Security Foundation"
                description="We help you execute your security strategy while building internal capabilities:"
                bulletPoints={[
                  "Establishment of governance structures for ongoing security accountability",
                  "Implementation of critical security controls to address immediate risks",
                  "Knowledge transfer to your team to ensure sustainable security management"
                ]}
                testimonial="Within weeks we had a functioning security program that actually accelerated our business instead of slowing it down."
              />
              
              <ProcessStep 
                number={4}
                title="Accelerate Business Growth"
                description="We ensure your security program continues to enable business success:"
                bulletPoints={[
                  "Regular strategy reviews to align security with evolving business needs",
                  "Proactive compliance management for new markets and opportunities",
                  "Ongoing advisory support to address emerging security challenges"
                ]}
                testimonial="Security is now a competitive advantage for us. Our customers choose us because they trust how we protect their data, and we can enter new markets faster than our competitors."
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
